/* @flow */


class Loading {
    show() {
        const elemento = document.getElementById('loading-mask');
        if (elemento) elemento.style.display = 'block';
    }
    hide() {
        const elemento = document.getElementById('loading-mask');
        if (elemento) elemento.style.display = 'none';
    }
}

export default new Loading();



// WEBPACK FOOTER //
// ./app/utils/Loading.js